import { render } from "./SearchItemMarumiya.vue?vue&type=template&id=5e5e13d7"
import script from "./SearchItemMarumiya.vue?vue&type=script&lang=ts"
export * from "./SearchItemMarumiya.vue?vue&type=script&lang=ts"
script.render = render

export default script